"use client";

interface InlineEditProps {
  value: string;
}

export function InlineEdit({ value }: InlineEditProps) {
  return (
    <div className="group relative inline-block">
      <span>{value}</span>
    </div>
  );
}
